export default __webpack_public_path__ + "static/media/icon5.255c6587.svg";